"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserLanguage = void 0;
function browserLanguage() {
    const languageInfo = {
        language: navigator.language,
    };
    if (navigator.userLanguage) {
        languageInfo.userLanguage = navigator.userLanguage;
    }
    if (navigator.browserLanguage) {
        languageInfo.browserLanguage = navigator.browserLanguage;
    }
    if (navigator.systemLanguage) {
        languageInfo.systemLanguage = navigator.systemLanguage;
    }
    return languageInfo;
}
exports.browserLanguage = browserLanguage;
//# sourceMappingURL=language.js.map